EMMY.tabsPanel = {
  init: function () {
    $('.tab-link').on('click', function(e){
      e.preventDefault();
      $('.tab-link').removeClass('is-active');
      $('.tab-content').removeClass('is-open');
      $(this).addClass('is-active');
      $(this).next().addClass('is-open');
    });

    var current = location.pathname;
    $('.accordion-tabs li a.sidebar-update').each(function (){
        var $this = $(this);
        if($this.attr('href').split('?')[0] === current){
            $this.addClass('active');
        }
    })
  }
}
